import { useState } from 'react';
import { AiOutlineEdit, AiOutlineSave } from 'react-icons/ai';
import { RiDeleteBin5Line } from 'react-icons/ri';
import { useTranslation } from 'react-i18next';
import { MwButton, MwInputText, MwTextArea } from '../../ui';

const AddressForm = ({
    errors,
    address,
    setAddress,
}) => {
    const [t] = useTranslation('global');
    const [editableMode, setEditableMode] = useState({ state: false, index: 0 });
    const [newAddress, setNewAddress] = useState({
        name: '',
        city: '',
        region: '',
        street: '',
        desc: '',
    });
    const [addressEditable, setAddressEditable] = useState({
        name: '',
        city: '',
        region: '',
        street: '',
        desc: '',
    });

    const editItem = (index, item) => {
        setEditableMode({ state: true, index });
        setAddressEditable(item);
    };

    const updateItem = (index) => {
        address[index] = addressEditable;
        setAddress([...address]);
        setEditableMode({ state: false, index });
    };

    const deleteItem = (index) => {
        const filter = address.filter((el, i) => i !== index);
        setAddress(filter);
    };

    const addNewHandler = () => {
        if (!newAddress.city) return;

        setAddress([...address, newAddress]);
        setNewAddress({
            name: '',
            city: '',
            region: '',
            street: '',
            desc: '',
        });
    };

    return (
        <>
            <div id='AddNewAddress'>
                <div className='flex-1 py-2'>
                    <MwInputText
                        label={t('vendors.name')}
                        id='newAddress.name'
                        value={newAddress.name}
                        invalid={!!errors.newAddressName}
                        invalidMsg={errors.newAddressName}
                        onChange={(e) => setNewAddress({ ...newAddress, name: e.target.value })}
                    />
                </div>

                <div className='flex justify-between gap-3'>
                    <div className='flex-1 py-2'>
                        <MwInputText
                            label={t('vendors.city')}
                            id='newAddressCity'
                            value={newAddress.city}
                            invalid={!!errors.newAddressCity}
                            invalidMsg={errors.newAddressCity}
                            onChange={(e) => setNewAddress({ ...newAddress, city: e.target.value })}
                        />
                    </div>

                    <div className='flex-1 py-2'>
                        <MwInputText
                            label={t('vendors.region')}
                            id='newAddressRegion'
                            value={newAddress.region}
                            invalid={!!errors.newAddressRegion}
                            invalidMsg={errors.newAddressRegion}
                            onChange={(e) => setNewAddress({ ...newAddress, region: e.target.value })}
                        />
                    </div>
                </div>

                <div className='py-2'>
                    <MwInputText
                        label={t('vendors.street')}
                        id='newAddressStreet'
                        value={newAddress.street}
                        invalid={!!errors.newAddressStreet}
                        invalidMsg={errors.newAddressStreet}
                        onChange={(e) => setNewAddress({ ...newAddress, street: e.target.value })}
                    />
                </div>

                <div className='py-2'>
                    <MwTextArea
                        label={t('vendors.description')}
                        id='newAddressDesc'
                        value={newAddress.desc}
                        rows={2}
                        onChange={(e) => setNewAddress({ ...newAddress, desc: e.target.value })}
                    />
                </div>

                <div id='Actions' className='flex justify-end'>
                    <MwButton type='saveBtn' actionType='button' onClick={addNewHandler}>
                        {t('vendors.save')}
                    </MwButton>
                </div>
            </div>

            {address && address.length > 0 && (
                <div id='ListAddresses' className='my-5'>
                    <div className='mb-3 text-sm font-semibold text-slate-700'>
                        {t('vendors.addressesList')}
                    </div>

                    <div className='overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm'>
                        <div className='overflow-auto custom-scrollbar'>
                            <table className='min-w-[980px] w-full border-collapse'>
                                <thead className='bg-slate-100 text-xs uppercase tracking-wide text-slate-500'>
                                    <tr>
                                        <th className='px-3 py-3 text-center font-semibold'>#</th>
                                        <th className='px-3 py-3 text-start font-semibold'>{t('vendors.name')}</th>
                                        <th className='px-3 py-3 text-start font-semibold'>{t('vendors.city')}</th>
                                        <th className='px-3 py-3 text-start font-semibold'>{t('vendors.area')}</th>
                                        <th className='px-3 py-3 text-start font-semibold'>{t('vendors.street')}</th>
                                        <th className='px-3 py-3 text-start font-semibold'>{t('vendors.description')}</th>
                                        <th className='px-3 py-3 text-center font-semibold'>{t('table.actions')}</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {address.map((addressItem, index) => (
                                        <tr key={index} className='border-b border-slate-100 text-sm text-slate-600 last:border-b-0'>
                                            <td className='px-3 py-3 text-center font-medium text-slate-500'>
                                                {index + 1}
                                            </td>
                                            <td className='px-3 py-3'>
                                                {editableMode.state && editableMode.index === index ? (
                                                    <MwInputText
                                                        classNameInput='text-start'
                                                        value={addressEditable.name}
                                                        onChange={(e) =>
                                                            setAddressEditable({
                                                                ...addressEditable,
                                                                name: e.target.value,
                                                            })
                                                        }
                                                    />
                                                ) : (
                                                    addressItem.name || t('vendors.noData')
                                                )}
                                            </td>
                                            <td className='px-3 py-3'>
                                                {editableMode.state && editableMode.index === index ? (
                                                    <MwInputText
                                                        classNameInput='text-start'
                                                        value={addressEditable.city}
                                                        onChange={(e) =>
                                                            setAddressEditable({
                                                                ...addressEditable,
                                                                city: e.target.value,
                                                            })
                                                        }
                                                    />
                                                ) : (
                                                    addressItem.city || t('vendors.noData')
                                                )}
                                            </td>
                                            <td className='px-3 py-3'>
                                                {editableMode.state && editableMode.index === index ? (
                                                    <MwInputText
                                                        classNameInput='text-start'
                                                        value={addressEditable.region}
                                                        onChange={(e) =>
                                                            setAddressEditable({
                                                                ...addressEditable,
                                                                region: e.target.value,
                                                            })
                                                        }
                                                    />
                                                ) : (
                                                    addressItem.region || t('vendors.noData')
                                                )}
                                            </td>
                                            <td className='px-3 py-3'>
                                                {editableMode.state && editableMode.index === index ? (
                                                    <MwInputText
                                                        classNameInput='text-start'
                                                        value={addressEditable.street}
                                                        onChange={(e) =>
                                                            setAddressEditable({
                                                                ...addressEditable,
                                                                street: e.target.value,
                                                            })
                                                        }
                                                    />
                                                ) : (
                                                    addressItem.street || t('vendors.noData')
                                                )}
                                            </td>
                                            <td className='px-3 py-3 align-top'>
                                                {editableMode.state && editableMode.index === index ? (
                                                    <MwInputText
                                                        classNameInput='text-start'
                                                        value={addressEditable.desc}
                                                        onChange={(e) =>
                                                            setAddressEditable({
                                                                ...addressEditable,
                                                                desc: e.target.value,
                                                            })
                                                        }
                                                    />
                                                ) : (
                                                    <span className='block min-w-[180px] whitespace-pre-wrap'>
                                                        {addressItem.desc || t('vendors.noData')}
                                                    </span>
                                                )}
                                            </td>
                                            <td className='px-3 py-3'>
                                                <div className='flex items-center justify-center gap-2'>
                                                    {editableMode.state && editableMode.index === index ? (
                                                        <MwButton actionType='button' type='secondary' size='sm' onClick={() => updateItem(index)}>
                                                            <AiOutlineSave size={18} />
                                                        </MwButton>
                                                    ) : (
                                                        <MwButton actionType='button' type='secondary' size='sm' onClick={() => editItem(index, addressItem)}>
                                                            <AiOutlineEdit size={18} />
                                                        </MwButton>
                                                    )}
                                                    <MwButton actionType='button' type='secondary' size='sm' onClick={() => deleteItem(index)}>
                                                        <RiDeleteBin5Line size={18} />
                                                    </MwButton>
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AddressForm;
